import { NavSection } from '@components/v2/layout/AppTemplate/appTemplate.types';
import { useEffect, useState } from 'react';
import SearchStringUtil from '../../../utils/searchString.utils';

interface UseSettingsMenuSearchParams {
  sections: NavSection[];
  isEnabled: boolean;
}

const filterSectionsByTerm = (sections: NavSection[], term: string): NavSection[] => {
  const normalizedTerm = SearchStringUtil.normalize(term);

  if (!normalizedTerm) {
    return sections;
  }

  return sections.reduce<NavSection[]>((filtered, section) => {
    const matchedItems = section.items.filter((item) =>
      SearchStringUtil.normalize(item.label).includes(normalizedTerm),
    );

    if (matchedItems.length > 0) {
      filtered.push({ ...section, items: matchedItems });
    }

    return filtered;
  }, []);
};

export const useSettingsMenuSearch = ({ sections, isEnabled }: UseSettingsMenuSearchParams) => {
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (!isEnabled) {
      setSearchTerm('');
    }
  }, [isEnabled]);

  const filteredSections = isEnabled ? filterSectionsByTerm(sections, searchTerm) : sections;

  const hasNoResults = isEnabled && Boolean(searchTerm) && filteredSections.length === 0;

  return { searchTerm, setSearchTerm, filteredSections, hasNoResults };
};
